import { render, staticRenderFns } from "./House.vue?vue&type=template&id=b3ab5a6e&scoped=true"
import script from "./House.vue?vue&type=script&lang=js"
export * from "./House.vue?vue&type=script&lang=js"
import style0 from "./House.vue?vue&type=style&index=0&id=b3ab5a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ab5a6e",
  null
  
)

export default component.exports